import { render } from "./BarChart.vue?vue&type=template&id=107897c5&ts=true"
import script from "./BarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./BarChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/BarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "107897c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('107897c5', __exports__)) {
    api.reload('107897c5', __exports__)
  }
  
  module.hot.accept("./BarChart.vue?vue&type=template&id=107897c5&ts=true", () => {
    api.rerender('107897c5', render)
  })

}


export default __exports__